import { render } from "./HistoryPoint.vue?vue&type=template&id=677ee316&scoped=true"
import script from "./HistoryPoint.vue?vue&type=script&lang=js"
export * from "./HistoryPoint.vue?vue&type=script&lang=js"

import "./HistoryPoint.vue?vue&type=style&index=0&id=677ee316&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677ee316"]])

export default __exports__